(function () {
  const ROOT_SEL = '.cg__container';
  let lastY = window.scrollY;

  function setDirFromScroll() {
    const y = window.scrollY;
    const delta = y - lastY;

    if (delta !== 0) {
      const dir = delta > 0 ? 1 : -1;

      document.querySelectorAll(ROOT_SEL).forEach((el) => {
        el.style.setProperty('--cg-direction', dir);
      });
    }

    lastY = y;
  }

  addEventListener('scroll', setDirFromScroll, { passive: true });

  addEventListener(
    'wheel',
    (e) => {
      if (e.deltaY !== 0) {
        const dir = e.deltaY > 0 ? 1 : -1;

        document.querySelectorAll(ROOT_SEL).forEach((el) => {
          el.style.setProperty('--cg-direction', dir);
        });
      }
    },
    { passive: true },
  );

  class CG {
    constructor(root) {
      this.root = root;
      this.track = root.querySelector('.cg__track');
      this.base = this.track.querySelector('.cg__item');

      this.prevBtn = root.querySelector('.cg__arrow--prev');
      this.nextBtn = root.querySelector('.cg__arrow--next');

      this.offset = 0;
      this.lastTs = null;
      this.mod = 1;

      this.hovering = false;
      this.resumeTimer = null;
      this.resumeDelay = 500; // ms

      this.reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.buildOnce();

      this.ro = new ResizeObserver(() => this.remeasureAndFill());
      this.ro.observe(this.root);

      matchMedia('(prefers-reduced-motion: reduce)').addEventListener('change', (e) => {
        this.reduced = e.matches;
      });

      this.bindEvents();

      requestAnimationFrame(this.loop);
    }

    bindEvents() {
      // Pause on hover
      this.root.addEventListener('mouseenter', () => {
        this.hovering = true;
        clearTimeout(this.resumeTimer);
      });

      this.root.addEventListener('mouseleave', () => {
        clearTimeout(this.resumeTimer);
        this.resumeTimer = setTimeout(() => {
          this.hovering = false;
        }, this.resumeDelay);
      });

      // Arrows
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => {
          this.nudge(-1);
        });
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => {
          this.nudge(1);
        });
      }
    }

    get speed() {
      const v = parseFloat(getComputedStyle(this.root).getPropertyValue('--cg-speed'));
      return Number.isNaN(v) ? 30 : Math.max(0, Math.min(v, 1000));
    }

    get direction() {
      const v = parseFloat(getComputedStyle(this.root).getPropertyValue('--cg-direction'));
      return v >= 0 ? 1 : -1;
    }

    buildOnce() {
      if (!this.base) return;

      this.track.innerHTML = '';
      this.track.appendChild(this.base);

      this.remeasureAndFill();

      this.offset = -0.01;
      this.apply();
    }

    remeasureAndFill() {
      this.seqWidth = this.base.getBoundingClientRect().width;

      if (this.seqWidth === 0) {
        const t = this.base.cloneNode(true);
        this.track.appendChild(t);
        this.seqWidth = this.base.getBoundingClientRect().width || t.getBoundingClientRect().width;
      }

      const need = this.root.getBoundingClientRect().width + this.seqWidth;

      const kids = Array.from(this.track.children);
      for (let i = kids.length - 1; i >= 1; i--) {
        this.track.removeChild(kids[i]);
      }

      let total = this.base.getBoundingClientRect().width;

      while (total < need) {
        const c = this.base.cloneNode(true);
        this.track.appendChild(c);
        total += this.seqWidth;
      }

      this.mod = this.seqWidth;
    }

    apply() {
      let o = this.offset % this.mod;

      if (o > 0) o -= this.mod;

      const snap = Math.round(o * 100) / 100;
      this.track.style.transform = `translate3d(${snap}px,0,0)`;
    }

    nudge(dir) {
      const amount = 200; // px per click

      this.hovering = true;
      clearTimeout(this.resumeTimer);

      this.offset += amount * dir;
      this.apply();

      this.resumeTimer = setTimeout(() => {
        this.hovering = false;
      }, this.resumeDelay);
    }

    loop = (ts) => {
      if (this.lastTs == null) this.lastTs = ts;

      const dt = (ts - this.lastTs) / 1000;
      this.lastTs = ts;

      const shouldMove = !this.reduced && !this.hovering;

      const v = shouldMove ? this.speed : 0;

      this.offset += v * this.direction * dt;

      this.apply();

      requestAnimationFrame(this.loop);
    };
  }

  document.querySelectorAll(ROOT_SEL).forEach((el) => {
    new CG(el);
  });
})();
